import UnBindPhone from './src/main'

export default {
  install(Vue, props) {
    Vue.prototype.$UnBindPhone = options => UnBindPhone(options, props)
  }
}
